import './LocAds.scss';

import { Button, Divider, InputLabel, SvgIcon } from '@mui/material';
import ButtonField from '../../Components/Button/ButtonField';
import Table from '../../Components/Table/Table';
import CustomToolbar from '../../Components/Table/components/CustomToolbar';
import TableSearch from '../../Components/Table/components/TableSearch';
import { ILocAdsList, MastersProps } from './ILocAds';
import {
  FunctionComponent,
  MouseEvent,
  SetStateAction,
  useEffect,
  useState,
} from 'react';
import { ReactComponent as Add } from '../../Assets/Images/Add.svg';
import { Columns } from '../../Components/Table/ITable';
import { useAppDispatch, useAppSelector } from '../../Redux/Store/Hooks';
import { getOwner } from '../../Redux/Slicers/Owner/OwnerSlicer';
import {
  GridActionsCellItem,
  GridRowParams,
  GridValueGetterParams,
} from '@mui/x-data-grid';
import { ReactComponent as Edit } from '../../Assets/Images/Edit.svg';
import { ReactComponent as Delete } from '../../Assets/Images/Delete.svg';
import Dialog from '../../Components/Dialog/Dialog';
import IconButtonField from '../../Components/Button/IconButtonField';
import { ReactComponent as Cancel } from '../../Assets/Images/Cancel.svg';
import { Formik, FormikProps, useFormik } from 'formik';

import {
  clearUpdateOwnerState,
  OwnerUpdateableData,
} from '../../Redux/Slicers/Owner/UpdateOwnerSlicer';
import ResponseDialog from '../../Components/ResponseDialog/ResponseDialog';
import DeleteDialog from '../../Components/DeleteDialog/DeleteDialog';

import {
  clearDeleteOwner,
  deleteOwner,
} from '../../Redux/Slicers/Owner/DeleteOwnerSlice';
import { clearAddOwnerState } from '../../Redux/Slicers/Owner/AddOwnerSlicer';
import UploadButtonField from '../../Components/Button/UploadButtonField';
import TextInputField from '../../Components/TextInput/TextInputField';
import * as Yup from 'yup';
import { Upload } from '@mui/icons-material';
import { useNavigate, useParams } from 'react-router-dom';
import { getOneLocation } from '../../Redux/Slicers/Location/GetOneLocationSlicer copy';
import RotateLeftRoundedIcon from '@mui/icons-material/RotateLeftRounded';
import {
  clearUpdateLocationState,
  updateLocation,
} from '../../Redux/Slicers/Location/UpdateLocationSlicer';
import { IAPIResponse } from '../../Redux/interfaces/IAPIResponse';
import { ReactComponent as View } from '../../Assets/Images/solar_eye-linear.svg';
import { getAds } from '../../Redux/Slicers/Location/GetAdsSlicer';
import AdsClickOutlinedIcon from '@mui/icons-material/AdsClickOutlined';
import ViewAds from './ViewAds';

interface ResponseDialogProps {
  response?: IAPIResponse<any>;
  parentDialog?: React.Dispatch<React.SetStateAction<boolean>>;
}

const Master: FunctionComponent<ResponseDialogProps> = () => {
  const nav = useNavigate();
  const { id }: any = useParams();
  const dispatch = useAppDispatch();
  const { data } = useAppSelector((state) => state?.GetOneLocation);
  const [open1, setOpen1] = useState<boolean>(false);
  const [opens, setOpens] = useState<boolean>(false);
  const [isHistoryOpen, setIsHistoryOpen] = useState<boolean>(false);

  const { data: updateLocations, updateableDate } = useAppSelector(
    (state) => state?.UpdateLocation
  );

  useEffect(() => {
    if (id) {
      dispatch(getOneLocation(id));
    }
  }, [updateableDate, updateLocations]);

  useEffect(() => {
    return () => {
      dispatch(clearUpdateLocationState());
    };
  }, []);

  const data1 = data?.response?.data?.ads_type || {};

  const masterFrom = useFormik({
    enableReinitialize: true,
    initialValues: {
      ads_title: data1?.title || "",
      ads_description: data1?.description || "",
      ads_link: data1?.link || "",
      ads_image: Array.isArray(data1?.images)
        ? data1?.images
        : data1?.images
        ? [data1?.images]
        : [],
    },
    validationSchema: Yup.object().shape({
      ads_title: Yup.string().required("Please enter Ads Title"),
      ads_description: Yup.string().required("Please enter Ads Description"),
      ads_link: Yup.string()
        .required("Please enter Ads Link")
        .url("Please enter a valid URL"),
      ads_image: Yup.array().min(1, "Please add at least one image"),
    }),
    onSubmit: (values) => {
      const formData = new FormData();

      values.ads_image.forEach((image: any, index: any) => {
        if (image) {
          if (image instanceof File) {
            formData.append("ads_image", image);
          } else if (typeof image === "string") {
            formData.append("ads_image", image);
          }
        }
      });

      formData.append("ads_title", values.ads_title);
      formData.append("ads_link", values.ads_link);
      formData.append("ads_description", values.ads_description);
      formData.append("key", "ad_update");
      localStorage.setItem("location", id);

      dispatch(updateLocation(formData));
    },
  });

  const handleClose = () => {
    nav('/location');
  };

  const handleReset = () => {
    masterFrom.resetForm();
    const formData = new FormData();
    formData.append('ads_image', '');
    formData.append('ads_title', '');
    formData.append('ads_link', '');
    formData.append('ads_description', '');
    formData.append('key', 'ad_update');
    localStorage.setItem('location', id);
    setOpen1(true);
    dispatch(updateLocation(formData));
  };

  const save_check = async () => {
    const errors = await masterFrom.validateForm();
    masterFrom.setTouched({
      ads_title: true,
      ads_description: true,
      ads_link: true,
      ads_image: true,
    });
    if (Object.keys(errors).length === 0) {
      setOpens(true);
    } else {
      setOpens(false);
      console.log('Validation errors:', errors);
    }
  };
  return (
    <div
      style={{
        width: '100%',
        backgroundColor: 'white',
        height: '90vh!important',
      }}>
      {/* <div>History of ads</div>
      <ButtonField
        onClick={() => {
          nav({
            pathname: `locAdsHistory/${id}`,
          });
          dispatch(getAds(id));
        }}>
        <View className="action_icons" />
      </ButtonField> */}

      <ButtonField
        sx={{
          backgroundColor: '#a6a6a6',
          color: 'black',
          float: 'right',
          margin: '20px',
        }}
        className="reset_button"
        onClick={() => setIsHistoryOpen(true)}>
        <AdsClickOutlinedIcon titleAccess="History"></AdsClickOutlinedIcon>
      </ButtonField>
      <ButtonField
        sx={{
          backgroundColor: '#a6a6a6',
          color: 'black',
          float: 'right',
          margin: '20px',
        }}
        className="reset_button"
        onClick={() => setOpen1(true)}>
        <RotateLeftRoundedIcon titleAccess="Reset form"></RotateLeftRoundedIcon>
      </ButtonField>
      <form
        className="vehicle_forms"
        onSubmit={masterFrom.handleSubmit}
        onReset={masterFrom.handleReset}
        autoComplete="off">
        <div className="tool">Location Ads</div>

        <Divider sx={{ width: '100%' }} />
        <TextInputField
          sx={{ width: '40%', margin: '20px' }}
          id="title"
          name="ads_title"
          label="Title"
          value={masterFrom.values.ads_title}
          onChange={masterFrom.handleChange}
          onBlur={masterFrom.handleBlur}
          helperText={
            masterFrom.touched.ads_title &&
            typeof masterFrom.errors.ads_title === 'string'
              ? masterFrom.errors.ads_title
              : undefined
          }
          error={
            masterFrom.touched.ads_title && Boolean(masterFrom.errors.ads_title)
          }
        />
        <TextInputField
          sx={{ width: '40%', margin: '20px' }}
          id="ads_description"
          name="ads_description"
          label="Ads Description"
          value={masterFrom.values.ads_description}
          onChange={masterFrom.handleChange}
          onBlur={masterFrom.handleBlur}
          helperText={
            masterFrom.touched.ads_description &&
            typeof masterFrom.errors.ads_description === 'string'
              ? masterFrom.errors.ads_description
              : undefined
          }
          error={
            masterFrom.touched.ads_description &&
            Boolean(masterFrom.errors.ads_description)
          }
        />
        <TextInputField
          sx={{ width: '40%', margin: '20px' }}
          id="ads_link"
          name="ads_link"
          label="Ads Link"
          value={masterFrom.values.ads_link}
          onChange={masterFrom.handleChange}
          onBlur={masterFrom.handleBlur}
          helperText={
            masterFrom.touched.ads_link &&
            typeof masterFrom.errors.ads_link === 'string'
              ? masterFrom.errors.ads_link
              : undefined
          }
          error={
            masterFrom.touched.ads_link && Boolean(masterFrom.errors.ads_link)
          }
        />
        <InputLabel style={{ fontSize: 'small', margin: '10px' }}>
          Ad Images
        </InputLabel>

        {masterFrom?.values?.ads_image?.map((image: any, index: any) => (
          <div
            key={index}
            className="image-container">
            <UploadButtonField
              sx={{ width: '40% !important', margin: '10px' }}
              className="upload_field"
              name={`ads_image_${index}`}
              onChange={(event) => {
                if (event.target.files?.length) {
                  if (event.target.files[0]?.size > 5 * 1024 * 1024) {
                    masterFrom.setFieldError(
                      'ads_image',
                      'File size must be 5MB or less.'
                    );
                    return;
                  }

                  const newImages = [...masterFrom.values.ads_image];
                  newImages[index] = event.target.files[0];
                  masterFrom.setFieldValue('ads_image', newImages);
                }
              }}
              fileAccept="image/jpeg,image/png,image/svg+xml,image/jpg">
              {image ? (
                <img
                  src={
                    typeof image === 'string'
                      ? `${process.env.REACT_APP_API_URL}/${image}`
                      : URL.createObjectURL(image as File)
                  }
                  alt={`ads_image_${index}`}
                  height={168}
                  onError={(e) => {
                    console.error(
                      `Failed to load image at index ${index}:`,
                      image
                    );
                  }}
                />
              ) : (
                <div style={{ width: '50%' }}>
                  <SvgIcon
                    component={Upload}
                    inheritViewBox
                  />
                  Supported Format : (1000 x 1000 px) <br /> png, jpg, svg, jpeg
                </div>
              )}
            </UploadButtonField>
            <IconButtonField
              onClick={() => {
                const newImages = masterFrom.values.ads_image.filter(
                  (_: any, i: any) => i !== index
                );
                masterFrom.setFieldValue('ads_image', newImages);
              }}>
              <Delete />
            </IconButtonField>
          </div>
        ))}

        <Button
          sx={{ width: '40% !important', margin: '10px' }}
          onClick={() => {
            if (masterFrom.values.ads_image.length >= 10) {
              masterFrom.setFieldError(
                'ads_image',
                'You can only add up to 10 images.'
              );
              return;
            }

            masterFrom.setFieldError('ads_image', ''); // Clear error if valid
            masterFrom.setFieldValue('ads_image', [
              ...masterFrom.values.ads_image,
              null,
            ]);
          }}
          variant="outlined"
          disabled={masterFrom.values.ads_image.length >= 10 ? true : false}>
          Add Image
        </Button>

        {masterFrom.errors.ads_image && (
          <div
            style={{
              color: '#BD0000',
              margin: '8px 0px 0px 8px',
              fontSize: '13px',
            }}>
            {typeof masterFrom.errors.ads_image === 'string'
              ? masterFrom.errors.ads_image
              : ''}{' '}
          </div>
        )}

        {masterFrom.touched.ads_image && (
          <div
            style={{
              color: '#BD0000',
              margin: '8px 0px 0px 8px',
              fontSize: '13px',
            }}>
            {typeof masterFrom.errors.ads_image === 'string'
              ? masterFrom.errors.ads_image
              : ''}
          </div>
        )}
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '90px',
          }}>
          <ButtonField
            className="cancell_button"
            onClick={() => {
              handleClose();
            }}>
            Cancel
          </ButtonField>
          <ButtonField
            className="addd_button"
            onClick={() => save_check()}>
            Save
          </ButtonField>
        </div>
      </form>
      <Dialog
        open={opens}
        dialogClassName="delete_dialog"
        dialogTitleClassName="master_dialog_title"
        Dialog_Title={
          <>
            Ads update
            <IconButtonField onClick={() => setOpens(false)}>
              <SvgIcon
                component={Cancel}
                inheritViewBox
              />
            </IconButtonField>
          </>
        }
        dialogContentClassName="delete_dialog_content"
        Dialog_Content={<>Are you sure you want to update Ads</>}
        dialogActionClassName="delete_dialog_action"
        Dialog_Actions={
          <>
            <ButtonField
              className="cancel_button"
              onClick={() => setOpens(false)}>
              Cancel
            </ButtonField>
            <ButtonField
              className="add_button"
              onClick={() => masterFrom.handleSubmit()}>
              save
            </ButtonField>
          </>
        }
      />
      <ResponseDialog
        response={updateLocations}
        parentDialog={!open1 ? setOpens : setOpen1}
      />
      <Dialog
        open={open1}
        dialogClassName="delete_dialog"
        dialogTitleClassName="master_dialog_title"
        Dialog_Title={
          <>
            Ads reset
            <IconButtonField onClick={() => setOpen1(false)}>
              <SvgIcon
                component={Cancel}
                inheritViewBox
              />
            </IconButtonField>
          </>
        }
        dialogContentClassName="delete_dialog_content "
        Dialog_Content={<>Are you sure you want to reset Ads</>}
        dialogActionClassName="delete_dialog_action"
        Dialog_Actions={
          <>
            <ButtonField
              className="cancel_button"
              onClick={() => setOpen1(false)}>
              Cancel
            </ButtonField>
            <ButtonField
              className="add_button"
              onClick={() => handleReset()}>
              save
            </ButtonField>
          </>
        }
      />
      <Dialog
        open={isHistoryOpen}
        dialogClassName="history-dialog"
        dialogTitleClassName="master_dialog_title"
        Dialog_Title={
          <>
            Ads History
            <IconButtonField onClick={() => setIsHistoryOpen(false)}>
              <SvgIcon
                component={Cancel}
                inheritViewBox
              />
            </IconButtonField>
          </>
        }
        dialogContentClassName="text-left"
        Dialog_Content={<ViewAds />}
        dialogActionClassName="delete_dialog_action"
        Dialog_Actions={
          <>
            <ButtonField
              className="cancel_button"
              onClick={() => setIsHistoryOpen(false)}>
              BACK
            </ButtonField>
          </>
        }
      />
    </div>
  );
};
export default Master;
